const translations = {
  'trinityCerttesol.seo.title': 'Accredited 160-Hour Trinity CertTESOL Course in Barcelona',
  'trinityCerttesol.seo.description': `TEFL Iberia's 160-hour accredited TEFL course in Barcelona, Spain, is professional, affordable, supportive and run in small groups. Book early and save 100€!`,
  'trinityCerttesol.sec1.title': 'Trinity CertTESOL Course',
  'trinityCerttesol.sec1.description':
    'Gain an internationally recognised TEFL certification in Barcelona in 4 weeks',
  'trinityCerttesol.sec1.weeks': '4 weeks',
  'trinityCerttesol.sec1.hours': '160 hours classroom time',
  'trinityCerttesol.sec1.cities': 'Barcelona',
  'trinityCerttesol.sec2.title': 'Discover A Rewarding New Career',
  'trinityCerttesol.sec2.description':
    'The Trinity CertTESOL course is considered the most complete course for new English teachers and is recognized across the globe. You’ll be prepared and qualified to find work here in Barcelona, or wherever your travels may take you.',
  'trinityCerttesol.sec2.benefitsTitle': 'This course is ideal for you if:',
  'trinityCerttesol.sec2.benefit1':
    'You have never taught before or have little formal experience.',
  'trinityCerttesol.sec2.benefit2':
    'You want to maximise your work opportunities with first-class training and an internationally recognised Trinity CertTESOL qualification.',
  'trinityCerttesol.sec2.benefit3': 'You need help with your move to Barcelona.',
  'trinityCerttesol.sec2.benefit4': 'You want to experience local culture.',
  'trinityCerttesol.sec2.ben1.title': 'Internationally Recognized Qualification',
  'trinityCerttesol.sec2.ben1.text':
    'Barcelona? Bangkok? Brazil? Trinity CertTESOL is accepted across the globe.',
  'trinityCerttesol.sec2.ben2.title': 'Practical Classroom Experience',
  'trinityCerttesol.sec2.ben2.text': 'You’ll build confidence by teaching groups of real students.',
  'trinityCerttesol.sec2.ben3.title': 'Small Group Sizes',
  'trinityCerttesol.sec2.ben3.text':
    'Our classes max out at 12, giving everybody access to an instructor.',
  'trinityCerttesol.sec2.ben4.title': 'Post-Grad Job Prospects',
  'trinityCerttesol.sec2.ben4.text':
    'We work hard to ensure that all our students find relevant work after graduation.',
  'trinityCerttesol.sec3.title': 'What’s Included?',
  'trinityCerttesol.sec3.benefit1': '160-hour Trinity CertTESOL course and qualification.',
  'trinityCerttesol.sec3.benefit2': 'Trinity CertTESOL examination and certificate fees.',
  'trinityCerttesol.sec3.benefit3': 'Expert tuition from professional teachers.',
  'trinityCerttesol.sec3.benefit4':
    'Access to our beautiful school library, high-speed wifi, computers.',
  'trinityCerttesol.sec3.benefit5': '6+ hours of observed teaching practice with real learners.',
  'trinityCerttesol.sec3.benefit6':
    'Job contacts and placement help – our host school hires exclusively from TEFL Iberia graduates.',
  'trinityCerttesol.sec3.benefit7': 'Dedicated course coordinator.',
  'trinityCerttesol.sec3.benefit8': 'Pre-course breakfast.',
  'trinityCerttesol.sec3.benefit9': 'Social calendar at the school.',
  'trinityCerttesol.sec3.benefit10': 'Hands-on job support (CV help, interview prep, orientation).',
  'trinityCerttesol.sec3.benefit11': 'Access to exclusive job opportunities.',
  'trinityCerttesol.sec3.fullPrice': 'FULL PRICE:',
  'trinityCerttesol.sec3.earlyBirdPrice': 'EARLY BIRD PRICE:',
  'trinityCerttesol.sec3.payInFull': 'Pay in full 4 weeks in advance',
  'trinityCerttesol.sec3.quotation':
    'I’m so glad I decided to attend TEFL Iberia for my certification. The entire staff is incredible. The instructors are terrific and the faculty is so supportive. They help you every step of the way, from relocation to assistance in helping you find a job after the course is complete. I highly recommend them!',
  'trinityCerttesol.sec7.title': ' Start Your Overseas <accent>Adventure Today</accent>',
  'trinityCerttesol.sec8.title': 'Course Curriculum And Timetable',
  'trinityCerttesol.sec8.description':
    'The Trinity CertTESOL course is 160 hours long and takes place over 4 weeks.<accent> The timetable is Monday - Friday, 09.30 - 18.00. </accent>',
  'trinityCerttesol.sec8.notification.title': 'Is English Not Your Native Language?',
  'trinityCerttesol.sec8.notification.description':
    'You need to demonstrate a C1 level in order to be able to do the course.',
  'btn.takeEnglisAssessment': 'Take English Assessment',
  'btn.downloadTrinitySyllabus': 'Download Trinity CertTESOL Syllabus',
  'common.faqs': 'Frequently Asked Questions',
  'trinityCerttesol.sec11.title': ' Other <accent>Popular Courses</accent>',
  'trinityCerttesol.sec11.description': 'Take your training to the next level with TEFL Iberia',
  'trinityCerttesol.sec11.course1': 'TEFL & Work Placement',
  'trinityCerttesol.sec11.course2': 'TEFL Gap Year',
  'trinityCerttesol.sec11.course3': 'Developing Teacher & Spanish',
  'trinityCerttesol.sec11.month': 'month',
  'trinityCerttesol.sec11.months': '3 month',
  'trinityCerttesol.sec11.days': '3 day course',
};

export default translations;
